// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-d2c83462] .dx-datagrid-rowsview .dx-row > td {\r\n    overflow: visible;\n}\n[data-v-d2c83462] .dx-editor-cell {\r\n    overflow: hidden !important;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
